<template>
  <v-app>
    <v-main>
      <v-container>
        <v-dialog :value="true"
                  max-width="300"
                  persistent
                  eager
                  hide-overlay
                  no-click-animation
        >
          <v-card>
            <v-card-title>{{ $dictionary.get('loading-title') }}</v-card-title>
            <v-card-text>
              <v-progress-linear indeterminate color="green darken-2" />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
/* eslint-disable no-param-reassign */
import { Buffer } from 'buffer';

export default {
  name: 'Loader',
  props: {},
  computed: {},
  mounted() {
    try {
      // eslint-disable-next-line no-undef
      this.$store.commit('ui/fullscreen', g_fullscreen);
    } catch (error) {
      this.$store.commit('ui/fullscreen', false);
    }

    // eslint-disable-next-line no-undef
    const keyword = Buffer.from(g_key).toString('base64');

    this.$store.commit('data/token', keyword);
    this.$store.commit('ui/mobile', this.isMobile());
    this.load();
    this.$profiler.end('Loader');
  },
  beforeCreate() {
    this.$profiler.start('Loader');
  },
  methods: {
    isMobile() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
    repairMode(settings) {
      const { has_delivery, has_pickup } = settings;
      const deliveryMode = this.$store.state.data.mode === 'delivery';
      const pickupMode = this.$store.state.data.mode === 'pickup';
      if ((deliveryMode && !has_delivery) || (pickupMode && !has_pickup)) {
        this.$store.commit('data/mode', null);
        this.$store.commit('data/point', null);
        this.$store.commit('data/area', null);
        this.$store.commit('data/address', null);
        this.$store.commit('data/address', null);
      }
    },
    async load() {
      this.addExternalLibraries();
      this.checkBasket();
      const data = await this.$essentia.fetch('shop/data');
      if (data && data.settings) {
        // this.forceAllTimeOK(data); // for debugging and testing
        this.repairMode(data.settings);
        this.processData(data);
        this.preloadImages();
        setTimeout(this.setLoaded, 50);
      } else {
        this.$store.commit('data/field', { field: 'loaded', value: false });
      }
    },
    processData(data) {
      if (data.settings.theme && data.settings.theme._id) {
        this.$store.commit('theme/all', data.settings.theme);
      }
      this.$store.commit('data/field', { field: 'settings', value: data.settings });
      this.$store.commit('data/field', { field: 'points', value: data.points });
      data.points.forEach(({ catalogues }) => {
        if (!Array.isArray(catalogues)) return;
        catalogues.forEach(({ content }) => {
          if (!Array.isArray(content)) return;
          content.forEach((item) => {
            if (item.commodity && item.commodity._id) {
              // eslint-disable-next-line no-param-reassign
              item.commodity = Object.freeze(this.processItem(item));
            }
          });
        });
      });
      this.$store.commit('data/sections', this.$content.getFlattened());
    },
    checkBasket() {
      const { items } = this.$store.state.basket;
      if (!Array.isArray(items)) {
        this.$store.commit('basket/clear');
      }
    },
    setLoaded() {
      this.$store.commit('data/field', { field: 'loaded', value: true });
    },
    addExternalLibraries() {
      const tags = [
        {
          tag: 'script',
          attrs: {
            async: null,
            defer: null,
            src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCTVI9Rzz9KaLEbCSP7MZwaYpKUCsz2hYc&libraries=geometry,places'
          }
        }, {
          tag: 'link',
          attrs: {
            rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900'
          }
        }, {
          tag: 'link',
          attrs: {
            rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css'
          }
        }
      ];
      tags.forEach((item) => {
        const el = document.createElement(item.tag);
        Object.keys(item.attrs).forEach((name) => {
          const value = item.attrs[name];
          if (value === null) {
            el[name] = true;
          } else {
            el.setAttribute(name, item.attrs[name]);
          }
        });
        document.head.appendChild(el);
      });
    },
    preloadImages() {
      const {
        file_image_lazy
      } = this.$store.state.data.settings;
      if (file_image_lazy && file_image_lazy.path) {
        new Image().src = this.$essentia.filePath(file_image_lazy);
      }
    },
    processItem(item) {
      if (!item) return {};
      const { commodity } = item;
      if (!commodity) return {};
      const out = { ...commodity };

      if (commodity.name === 'Бенедикт с ветчиной') {
        console.log(item);
      }

      if (out.price && typeof out.price === 'object') {
        out.price = Number(out.price.amount || 0);
      }

      if (commodity.price && typeof commodity.price === 'object') {
        commodity.price = Number(commodity.price.amount || 0);
      }

      if (item.price && typeof item.price === 'object') {
        item.price = Number(item.price.amount || 0);
      }

      if (out.price_discounted && typeof out.price_discounted === 'object') {
        out.price_discounted = Number(out.price_discounted.amount || 0);
      }

      const { price_discounted } = out;

      const {
        show_tags, show_product_ingredients, readonly, file_image_placeholder, file_image_lazy
      } = this.$store.state.data.settings;
      if (commodity.image && commodity.image.sizes && commodity.image.sizes.m) {
        out.image = commodity.image.sizes.m;
      } else if (commodity.images
        && Array.isArray(commodity.images)
        && commodity.images.length
        && commodity.images[0].sizes) {
        out.image = commodity.images[0].sizes.m;
      } else if (file_image_placeholder && file_image_placeholder.path) {
        out.image = file_image_placeholder.path;
        out.noimage = true;
      } else {
        out.image = null;
      }

      if (out.image && commodity.image) {
        out.image = this.$essentia.filePath({ source: commodity.image.source, path: out.image });
      }

      out.imageLazy = file_image_lazy ? this.$essentia.filePath(file_image_lazy) : null;
      out.readonly = readonly;

      out.name = item.alias || commodity.name || commodity._id;
      out.weight = this.$tools.weight(commodity.weight);
      const price = item.price || commodity.price || null;
      out.price = this.$tools.money(price);
      out.priceDiscounted = this.$tools.money(out.price_discounted);
      out.priceFinal = (price_discounted > 0 && price_discounted < price) ? price_discounted : price;
      if (out.ingredients && Array.isArray(out.ingredients)) {
        if (!show_product_ingredients) {
          out.ingredients = null;
        } else {
          out.ingredients = out.ingredients.join(', ');
        }
      }
      if (!show_tags) {
        out.tags = [];
      }
      return out;
    },
    forceAllTimeOK(data) {
      data.points.forEach((point) => {
        point.delivery_time_ok = true;
        point.order_time_ok = true;
        point.catalogues.forEach((cat) => {
          cat.time_limited = false;
          cat.time_ok = true;
        });
      });
    }
  },
};
</script>
